import { cva } from "class-variance-authority"

// The value span truncates, never line-clamps: Safari's -webkit-box clamp
// cuts the first word of a flex value ("Fazi…" beside its badge, FUS-2775).
export const selectTriggerVariants = cva(
  "ui-select-trigger text-foreground flex w-full items-center justify-between whitespace-nowrap rounded-md ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:truncate",
  {
    variants: {
      variant: {
        outline: "border border-input bg-transparent shadow-sm",
        secondary:
          "bg-secondary text-secondary-foreground border border-transparent",
        ghost: "border border-transparent",
      },
      size: {
        tiny: "h-6 text-xs px-2 py-1 rounde-sm",
        xs: "h-7 text-sm px-2 py-1 rounded-sm",
        sm: "h-8 text-sm px-3 py-1.5 rounded-sm",
        md: "h-9 text-sm px-3 py-2",
        lg: "h-10 text-base px-3 py-2",
      },
    },
    defaultVariants: {
      variant: "outline",
      size: "md",
    },
  },
)
